import React, { Component } from "react";

import Modal from "react-modal";

import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";

let strings = new LocalizedStrings({ en });

class DeleteView extends Component {
  state = {};

  componentWillMount() {
    Modal.setAppElement("body");
  }
  render() {
    return (
      <Modal className="delete-view center" isOpen={true}>
        <div className="delete-view-container center">
          <div className="">{this.props.message}</div>
          <div className="delete-view-btn">
            <button className="btn btn-danger" onClick={this.props.delete}>
              {strings.yes}
            </button>
          </div>
          <div className="delete-view-btn">
            <button
              className="btn btn_primary btn-secondary"
              onClick={this.props.cancel}
            >
              {strings.cancel}
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default DeleteView;



// WEBPACK FOOTER //
// ./src/components/view/delete.jsx